export const fetch = (url: string, options?: any) => {
  return window.fetch(url, {
    ...options,
    credentials: "same-origin"
  });
};
